// extracted by mini-css-extract-plugin
export var md = "768px";
export var multipleContainer = "Subquestion_multipleContainer__v9dxd";
export var questionLabel = "Subquestion_questionLabel__5g5rl";
export var radioButton = "Subquestion_radioButton__7lEGa";
export var shared = "'../../../shared.module.css'";